import styled from "styled-components";

export const StyledReviewStore = styled.div`
    width: 100%;

    .title {
        color: var(--text-color);
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 30px;
    }

    .banner {
        width: 100%;
        height: auto;
        max-height: 230px;
        object-fit: cover;
        border-radius: 14px 14px 0 0;
    }
    .details-wrap {
        padding: 0 20px;
        margin-top: -75px;
        .logo {
            display: block;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            margin-bottom: 20px;
        }
        .title {
            display: block;
            color: var(--text-color);
            font-size: 28px;
            line-height: 32px;
            font-weight: 600;
            margin-bottom: 20px;
        }
        .location-wrap {
            display: block;
            color: rgba(143, 143, 143, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            margin-bottom: 20px;
        }
        .category-wrap {
            display: flex;
            align-items: center;
            gap: 10px;
            list-style: none;
            margin-bottom: 22px;
            li {
                padding: 10px;
                border-radius: 27px;
                color: var(--text-color);
                background: rgba(245, 126, 42, 0.15);
                box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
                backdrop-filter: blur(20px);
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
            }
        }

        .cuisines-wrap,
        .hours-wrap,
        .menu-wrap {
            margin-bottom: 15px;
            
            strong {
                display: inline-block;
                color: var(--text-color);
                font-size: 16px;
                font-weight: 600;
                margin-right: 5px;
            }
            
            span {
                color: rgba(143, 143, 143, 1);
                font-size: 16px;
                font-weight: 400;
                line-height: 20px;
            }
        }

        .btn-holder {
            display: flex;
            justify-content: center;
            margin-top: 30px;
        }
    }
`;
